<template>
  <main-layout>

    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-03"></menubar>
    </div>
    <!--  ヘッダー行の  -->
    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">{{$t('title.system.owner.title')}}</label>
        <sp-smart-button @click="backSearchOwner" slot="cancel">{{ $t("button.common.data.cancel") }}</sp-smart-button>
        <narrow-down @click="editOwner" slot="create">{{ $t("button.common.data.create") }}</narrow-down>
      </head-title>
    </el-row>

    <div slot="body">
      <!-- subtitle -->
      <div class="main-title">
        {{$t("title.system.owner.edit")}}
      </div>

      <el-row class="must-top m-bottom-5">
        <span style="color: #e65245">* </span>{{ $t("label.common.must") }}
      </el-row>
      <!--  フォーム開始  -->
      <el-row>
        <div>
          <el-form
            label-position="left"
            :rules="rules"
            :model="ownerDetailInfo"
            label-width="204px"
            class="submit-form"
            ref="ruleForm"
          >
            <el-row>
              <div class="width-204 float-left">
                <label class="lb1">{{"基本情報"}}</label>
              </div>
              <div class="width-528 float-left">
                 <el-row class="height-44">
                    <!--  オーナーID  -->
                    <el-form-item
                      :label="$t('label.system.owner.edit.ownerExId')"
                      prop="ownerExId"
                      size="small"
                      class="asterisk line-height-44">
                      <div class="edit-content">
                        {{ownerDetailInfo.ownerExId}}
                      </div>
                    </el-form-item>
                  </el-row>

                <el-row class="height-44">
                  <!--  オーナー名  -->
                  <el-form-item
                    :label="$t('label.system.owner.edit.ownerName')"
                    prop="ownerName"
                    size="small"
                    class="asterisk line-height-44">

                    <div class="edit-content" v-if="$checkRole('0301')">
                      {{ownerDetailInfo.ownerName}}
                    </div>
                    <el-input
                      size="small"
                      v-model="ownerDetailInfo.ownerName"
                      maxlength="50"
                      show-word-limit
                      v-if="!$checkRole('0301')"
                      placeholder="例：丸一不動産商事"
                      class="lang-width-input owner-edit-form show-word-limt-input-iot"/>
                  </el-form-item>
                </el-row>
              </div>
            </el-row>

            <hr class="delimiter-60" />

            <el-row>
              <div class="width-204 float-left">
                <label class="lb1">{{"基本ポイント設定"}}</label>
              </div>
              <div class="width-528 float-left">

                <el-row class="pointRate height-44">
                  <!--  締め日  -->
                  <el-form-item
                    :label="$t('label.system.owner.create.pointSime')"
                    prop="closeDate"
                    size="small"
                    class="asterisk line-height-44"
                  >
                    <el-row class="form-group">
                      <div class="width-120">
                        <el-select
                          v-model="ownerDetailInfo.closeDate"
                          size="small"
                          placeholder=""
                        >
                          <el-option
                            v-for="item in closeDateList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </div>
                    </el-row>
                  </el-form-item>
                </el-row>

                <el-row class="pointRate height-44">
                  <!--  デフォルト有効期限  -->
                  <el-form-item
                    :label="$t('label.system.owner.create.expirationMonth')"
                    prop="expirationMonth"
                    size="small"
                    class="asterisk line-height-44"
                  >
                    <el-row class="form-group">
                      <div class="width-120">
                        <el-select
                          v-model="ownerDetailInfo.expirationMonth"
                          size="small"
                          placeholder=""
                        >
                          <el-option
                            v-for="item in expirationMonthList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </div>
                      <div class="m-left-2">
                        <span class="c-ivory01">
                          {{ $t('label.system.owner.create.month') }}
                        </span>
                      </div>
                    </el-row>
                  </el-form-item>
                </el-row>
                <el-row class="pointRate height-44">
                  <!--  ポイント手数料率  -->
                  <el-form-item
                    :label="$t('label.system.owner.edit.pointFeeRate')"
                    prop="pointFeeRate"
                    size="small"
                    class="asterisk line-height-44">
                    <el-row class="form-group">
                      <div class="width-120">
                        <el-input
                          size="small"
                          maxlength="5"
                          placeholder="例：0.5"
                          v-model="ownerDetailInfo.pointFeeRate">
                        </el-input>
                      </div>
                      <div class="m-left-2">
                        <span  class="c-ivory01">%</span>
                      </div>
                    </el-row>
                  </el-form-item>
                </el-row>

                <el-row class="pointRate height-44 margin-bottom-0">
                  <!--  ポイント変換率  -->
                  <el-form-item
                    :label="$t('label.system.owner.edit.pointExcRate')"
                    prop="pointExcRate"
                    size="small"
                    class="asterisk line-height-44">
                    <el-row class="form-group">
                      <div class="width-120">
                        <el-input
                          size="small"
                          maxlength="6"
                          placeholder="例：0.5"
                          v-model="ownerDetailInfo.pointExcRate">
                        </el-input>
                      </div>
                      <div class="m-left-2">
                        <span class="c-ivory01">%</span>
                      </div>
                    </el-row>
                  </el-form-item>
                </el-row>
              </div>
            </el-row>

            <hr class="delimiter-60" />

            <!--  責任者情報部分 開始  -->
            <el-row>
              <div class="width-204 float-left">
                <label class="lb1">{{ $t("label.system.owner.edit.responsibleInformation") }}</label>
              </div>
              <div class="width-528 float-left">
                <el-row class="height-44">
                  <!--  氏名  -->
                  <el-form-item
                    prop="respUserName"
                    :label="$t('label.system.owner.edit.respUserName')"
                    size="small"
                    class="owners-search-respUserName line-height-44">
                    <el-row>
                      <div class="width-120 float-left">
                        <el-input
                          maxlength="20"
                          size="small"
                          placeholder="例：佐藤"
                          v-model="ownerDetailInfo.respUserName"
                          class="show-word-limt-input-iot-small"
                          show-word-limit
                        />
                      </div>
                    </el-row>
                  </el-form-item>
                </el-row>

                <el-row class="height-44">
                  <!--  電話番号  -->
                  <el-form-item
                    :label="$t('label.system.owner.edit.respUserTel')"
                    size="small"
                    class="line-height-44"
                    prop="respUserTel">
                    <el-input
                      size="small"
                      maxlength="20"
                      v-model="ownerDetailInfo.respUserTel"
                      placeholder="例：01234567890123456789"
                      show-word-limit
                      class="display-inline-block  lang-width-input owner-edit-form show-word-limt-input-iot"/>
                  </el-form-item>
                </el-row>

                <el-row class="height-44">
                  <!--  メールアドレス  -->
                  <el-form-item
                    :label="$t('label.system.owner.edit.respUserEmail')"
                    size="small"
                    class="line-height-44"
                    prop="respUserEmail">
                    <el-input
                      maxlength="319"
                      size="small"
                      v-model="ownerDetailInfo.respUserEmail"
                      placeholder="例：user1@test.jp"
                      class="display-inline-block  lang-width-input owner-edit-form"
                    />
                  </el-form-item>
                </el-row>

                <el-row class="height-44 margin-bottom-0">
                  <!--  契約番号  -->
                  <el-form-item
                    :label="$t('label.system.owner.edit.respUserContractNo')"
                    size="small"
                    class="line-height-44"
                    prop="respUserContractNo">
                    <el-input
                      size="small"
                      maxlength="20"
                      placeholder="例：N0000001"
                      v-model="ownerDetailInfo.respUserContractNo"
                      show-word-limit
                      class="display-inline-block  lang-width-input owner-edit-form show-word-limt-input-iot"
                    />
                  </el-form-item>
                </el-row>
              </div>
            </el-row>
            <!--  責任者情報部分 終わり  -->

            <hr class="delimiter-60" />

            <!--  本社情報 開始  -->
            <el-row>
              <div class="width-204 float-left">
                <label class="lb1">{{ $t("label.system.owner.edit.headquartersInformation") }}</label>
              </div>
              <div class="width-528 float-left">

                <el-row class="height-44">
                  <!--  住所  -->
                  <el-form-item
                    :label="$t('label.system.owner.create.companyAddress')"
                    size="small"
                    class="line-height-44"
                    prop="companyAddress">
                    <el-input
                      maxlength="200"
                      size="small"
                      placeholder="例：東京都港区赤坂５－７５２"
                      v-model="ownerDetailInfo.companyAddress"
                      show-word-limit
                      class="show-word-limt-input-iot owner-edit-form"/>
                  </el-form-item>
                </el-row>

                <el-row class="height-44 margin-bottom-0">
                  <!--  電話番号  -->
                  <el-form-item
                    :label="$t('label.system.owner.create.companyTel')"
                    size="small"
                    class="line-height-44"
                    prop="companyTel">
                    <el-input
                      maxlength="20"
                      size="small"
                      placeholder="例：01234567890123456789"
                      show-word-limit
                      v-model="ownerDetailInfo.companyTel"
                      class="show-word-limt-input-iot owner-edit-form"/>
                  </el-form-item>
                </el-row>
              </div>
            </el-row>

            <!--  本社情報 終わり  -->
            <hr class="delimiter-60" />

            <el-row>
                <div class="width-204 float-left">
                  <label class="lb1">{{"サービス開通/停止"}}</label>
                </div>
                <div class="float-left">
                  <el-row>
                    <!--  サービス開通日時  -->
                    <el-row type="flex" align="middle" class="m-bottom-5">
                      <div class="float-left">
                        <el-form-item
                          class="asterisk"
                          prop="serviceStartDt"
                          label="サービス開通日時"
                          :rules="startDate">
                          <div class="form-group">
                            <div class="edit-content" v-if="$checkRole('0301')">
                              {{this.showServiceStartDt}}
                            </div>
                            <div class="el-date-editor-box" v-if="!$checkRole('0301')">
                              <el-date-picker
                                class="date-picker-background-color"
                                value-format="yyyy/MM/dd"
                                type="date"
                                :clearable="false"
                                @blur="this.$reset"
                                @change="startTimeSelect"
                                :format="'yyyy年M月d日'+' '+'('+ [weekDays]+')'"
                                v-model="ownerDetailInfo.serviceStartDt"
                                />
                            </div>
                            <el-select v-if="!$checkRole('0301')"
                              class="date-time-select m-left-2"
                              placeholder=""
                              v-model="ownerDetailInfo.startTime">
                                <el-option
                                  v-for="item in timeList"
                                  :value="item"
                                  :key="item"
                                  :label="item">
                                </el-option>
                                <!--  -->
                            </el-select>
                          </div>

                        </el-form-item>
                      </div>
                    </el-row>
                    <!--  サービス停止日時  -->
                    <el-row type="flex" align="middle">
                      <div class="float-left">
                        <el-form-item
                          prop="serviceEndDt"
                          label="サービス停止日時"
                          :rules="endDate">
                          <div class="form-group">
                            <div class="edit-content" v-if="$checkRole('0301')">
                              {{this.showServiceEndDt}}
                            </div>
                            <div class="el-date-editor-box">
                              <el-date-picker
                                v-if="!$checkRole('0301')"
                                class="date-picker-background-color"
                                :clearable="false"
                                type="date"
                                @blur="this.$reset"
                                @change="endTimeSelect"
                                value-format="yyyy/MM/dd"
                                :format="'yyyy年M月d日'+' '+'('+ [weekDay]+')'"
                                v-model="ownerDetailInfo.serviceEndDt">
                              </el-date-picker>
                            </div>
                            <el-select
                              v-if="!$checkRole('0301')"
                              class="date-time-select m-left-2"
                              placeholder=""
                              v-model="ownerDetailInfo.endTime">
                                <el-option
                                  v-for="item in timeList"
                                  :value="item"
                                  :key="item"
                                  :label="item">
                                </el-option>
                            </el-select>
                            <div v-if="!$checkRole('0301')" class="float-left m-left-2">
                              <select-btn @click="clearEndDate" class="clear-width">
                                クリア
                              </select-btn>
                            </div>
                          </div>
                        </el-form-item>
                      </div>
                    </el-row>
                  </el-row>
                </div>
              </el-row>

              <narrow-down
                class="m-top-60 m-left-408"
                @click="editOwner">
                {{ $t("button.common.data.create") }}
              </narrow-down>

          </el-form>
        </div>
      </el-row>

      <hr class="delimiter-60"/>

      <el-row class="detail-area">
        <el-col :span="4">
          <label class="lb1">{{ $t("label.system.owner.edit.useList") }}</label>
        </el-col>

        <el-col :span="20">
          <el-table
            width="100%"
            class="table-header-th-top-0"
            :data="ownerDetailInfo.userList"
          >
            <el-table-column
              class-name="col-2"
              :label="$t('label.system.owner.edit.respUserName')"
            >
            <span slot-scope="scope">
              <span style="cursor:pointer" @click="goAccountDetail(scope.row.id)">{{ scope.row.name }}</span>
            </span>
            </el-table-column>
            <el-table-column
              class-name="col-2"
              :label="$t('label.system.owner.edit.respUserEmail')"
            >
            <span slot-scope="scope">
              {{ scope.row.email }}
            </span>
            </el-table-column>
            <el-table-column
              class-name="col-6"
              prop="role"
              :label="$t('label.system.owner.edit.role')"
            >
            <span slot-scope="scope">
              {{ scope.row.role }}
            </span>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-dialog-prompt
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        :msgParam="msgParam"
        @on-isPassParam="isPassParam">
      </el-dialog-prompt>

      <el-dialog-prompt
        :centerDialogVisibleParam.sync="errorMsgsShow"
        :msgParam="msgsError">
      </el-dialog-prompt>

      <el-dialog-prompt
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        :msgParam="msgParam"
        @on-isPassParam="isPassParam">
      </el-dialog-prompt>

      <!--  表单 終わり  -->
      <loading-dialog :dialogVisible="showLoading" />
    </div>
  </main-layout>
</template>

<script>
import OwnerEditRuleFactory from "@/rules/rule-owner-edit";
import NewDesignLayout from "@/layout/NewDesignLayout";
import SystemManageApi from "@/api/SystemManageApi";
import LoadingDialog from "@/components/common/loading/LoadingDialog";
// 引入按钮组件
import headTitle from "@/components/common/head/head";
import Menubar from "@/components/leftmenu/DashBoard"
import SpSmartButton from "@/components/common/sp-smart-button";
import narrowDown from "@/components/common/generalButton/NarrowDown";
import { codeOfValue } from "@/utils/parse-date";
import moment from 'moment';
import selectBtn from "@/components/common/generalButton/Select"
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import elDialogPrompt from "@/components/common/el-dialog-prompt"
const weeksDay = ["日", "月", "火", "水", "木", "金", "土"];

export default {
  name: "OwnerEdit",
  components: {
    LoadingDialog: LoadingDialog,
    headTitle,
    Menubar,
    selectBtn,
    SpSmartButton,
    narrowDown,
    MainLayout: NewDesignLayout,
    elDialogPrompt
  },
  data() {
    var validateStartDate = (rule,value,callback) => {
      if(this.$checkDateChange(this.firstServiceStartDt,this.ownerDetailInfo.serviceStartDt, this.ownerDetailInfo.startTime)) {
        this.$checkServceStartDate(this.ownerDetailInfo.serviceStartDt, this.ownerDetailInfo.startTime,callback);
      }
      this.$CheckFromToDate(this.ownerDetailInfo.serviceStartDt, this.ownerDetailInfo.serviceEndDt,
                            this.ownerDetailInfo.startTime, this.ownerDetailInfo.endTime,
                            this.$t('label.system.messageSearch.startDateStart'),
                            this.$t('label.system.messageSearch.startDateEnd'),
                            callback
                            )
    }
    var validateEndDate = (rule,value,callback) =>{
      this.$refs["ruleForm"].validateField("serviceStartDt");
      this.$checkServceEndDate(this.ownerDetailInfo.serviceEndDt, this.ownerDetailInfo.endTime,callback);
      callback()
    }
    return {
      firstServiceStartDt:null,
      msgParam: this.$t("message.common.isSave",{
        field: "オーナー"
      }),
      centerDialogVisibleIsShow: false,
      msgError: "ポイント手数料率を100を超えることはできません。",
      msgsError: "ポイント変換率を100を超えることはできません。",
      errorMsgShow: false,
      errorMsgsShow: false,
      timeList:[],
      weekDays: "",
      weekDay: "",
      paramOwnerId: null,
      showLoading: false,
      closeDateList: [],
      expirationMonthList: [],
      ownerDetailInfo: {
        startTime:null,
        endTime:null,
        ownerId: null,
        ownerExId: null,
        ownerName: null,
        pointFeeRate: 0,
        pointExcRate: 0,
        closeDate: 31,
        expirationMonth: 6,
        respUserName: null,
        respUserTel: null,
        respUserEmail: null,
        respUserContractNo: null,
        companyAddress: null,
        companyTel: null,
        lastUserName:null,
        firstUserName:null,
        closeDateOld: null,
        postalCode:null,
        respUser: {
          name: null,
          tel: null,
          email: null,
          contractNo: null,
        },
        company: {
          address: null,
          tel: null,
        },
        serviceStartDt: null,
        serviceEndDt: null,
        userList: [
          {
            id:null,
            name: null,
            email: null,
            role: null,
          },
        ],
      },
      rules: OwnerEditRuleFactory.editRules(this),
      startDate:
      [
        {
          required: true,
          trigger: 'change',
          message: this.$t('message.common.validation.required', {
            field: this.$t('label.system.owner.create.serviceStartDt')
          })
        },
        { validator: validateStartDate, trigger: 'change' },
      ],
      endDate:
      [
        { validator: validateEndDate, trigger: 'change' },
      ]
    };
  },
  watch: {
    "ownerDetailInfo.serviceStartDt"(val) {
      if(val == null || val == "") {
        this.ownerDetailInfo.startTime = null
      }
    },
    "ownerDetailInfo.serviceEndDt"(val) {
      if(val == null || val == "") {
        this.ownerDetailInfo.endTime = null
      }
    }

  },
  mounted() {
    this.paramOwnerId = this.$route.params.ownerId;
    this.loadownerDetailInfo();
  },
  methods: {
    clearEndDate () {
      this.ownerDetailInfo.serviceEndDt = null
      this.ownerDetailInfo.endTime = null
    },
    codeOfValue,
    //每隔四位加一个中划线
    companyPhone() {
      let str = this.ownerDetailInfo.companyTel;
      if (str.length > 4) {
        this.ownerDetailInfo.companyTel = this.ownerDetailInfo.companyTel
          .replace(/\s/g, " ")
          .replace(/([0-9a-zA-Z]{4})(?=\d)/g, "$1-");
      }
    },
    //所有者の取得
    loadownerDetailInfo() {
      this.showLoading = true;
      SystemManageApi.detailOwnerForPageInit(this.paramOwnerId)
      .catch((error) => {
        errorCodeMsg(error, this)
      })
        .then(({ data }) => {
          if(!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          this.ownerDetailInfo.ownerId = data.body.ownerDetail.id;
          this.ownerDetailInfo.ownerExId = data.body.ownerDetail.exId;
          this.ownerDetailInfo.ownerName = data.body.ownerDetail.name;
          this.ownerDetailInfo.pointFeeRate =this.$ChangePointRate(data.body.ownerDetail.feeRate);
          this.ownerDetailInfo.pointExcRate =this.$ChangePointRate(data.body.ownerDetail.exchangeRate);
          this.ownerDetailInfo.respUserName = data.body.ownerDetail.resUserName;
          this.ownerDetailInfo.respUserTel = data.body.ownerDetail.resUserTelNo;
          this.ownerDetailInfo.respUserEmail =
            data.body.ownerDetail.resUserEmail;
          this.ownerDetailInfo.respUserContractNo =
            data.body.ownerDetail.resUserContractNo;

          this.ownerDetailInfo.companyAddress =
            data.body.ownerDetail.companyAddress;
          this.ownerDetailInfo.companyTel = data.body.ownerDetail.companyTelNo;

          this.ownerDetailInfo.closeDate = data.body.ownerDetail.closeDate;
          this.ownerDetailInfo.closeDateOld = data.body.ownerDetail.closeDate
          this.ownerDetailInfo.expirationMonth = data.body.ownerDetail.expirationMonth;

          this.firstServiceStartDt = moment(data.body.ownerDetail.serviceStartDateTime).format("YYYY/MM/DD HH:mm");
          this.ownerDetailInfo.serviceStartDt = moment(data.body.ownerDetail.serviceStartDateTime).format("YYYY/MM/DD");
          this.ownerDetailInfo.startTime = moment(data.body.ownerDetail.serviceStartDateTime).format("HH:mm")
          if(!this.$IsNullOrEmpty(data.body.ownerDetail.serviceEndDateTime)) {
            this.ownerDetailInfo.serviceEndDt = moment(data.body.ownerDetail.serviceEndDateTime).format("YYYY/MM/DD");
            this.ownerDetailInfo.endTime = moment(data.body.ownerDetail.serviceEndDateTime).format("HH:mm")
            this.weekDay = weeksDay[new Date(this.ownerDetailInfo.serviceEndDt).getDay()]
          }

          this.weekDays = weeksDay[new Date(this.ownerDetailInfo.serviceStartDt).getDay()];


          this.showServiceStartDt = moment(this.ownerDetailInfo.serviceStartDt).format('YYYY年M月D日  (dd) ') + this.ownerDetailInfo.startTime
          if(this.ownerDetailInfo.serviceEndDt !=null){
            this.showServiceEndDt   = moment(this.ownerDetailInfo.serviceEndDt).format('YYYY年M月D日  (dd) ') + this.ownerDetailInfo.endTime
          }

          for (let user of data.body.accountList) {
            this.ownerDetailInfo.userList.push({
              id:user.id,
              name: user.fullname,
              email: user.email,
              role: codeOfValue(user.roleList),
            });
          }
        })
        .catch((error) => {
          // TODO: 権限チェック
          error;
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    /**
     * 所有者更新所有者情報
     */
    editOwner() {
      // var rule = this.endDate[0];
      // this.endDate.pop(0);
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.centerDialogVisibleIsShow = true
        }
      });
      // this.endDate.push(rule);
    },

    isPassParam(param){
      if(param){
        this.updateOwner();
      }
    },

    /**
     * オーナーに戻る
     */
    backSearchOwner() {
      this.$router.push({
        name: "system-owner-detail",
      });
    },

    /**
     * 所有者の更新
     */
    updateOwner() {
      this.centerDialogVisibleIsShow = false;
      this.showLoading = true;
      let pointFeeRate = null
      let pointExchangeRate = null
      if(this.ownerDetailInfo.pointFeeRate) {
         let int = parseFloat(this.ownerDetailInfo.pointFeeRate)/100
         let number = String(int).replace(/^(.*\..{4}).*$/ ,"$1");
         pointFeeRate = Number(number)
      }
      if(this.ownerDetailInfo.pointExcRate) {
         let int = parseFloat(this.ownerDetailInfo.pointExcRate)/100
         let number = String(int).replace(/^(.*\..{4}).*$/ ,"$1");
         pointExchangeRate = Number(number)
      }
      let serviceStartDate = this.ownerDetailInfo.serviceStartDt + ' ' +this.ownerDetailInfo.startTime
      let serviceEndDate = null
      if(this.ownerDetailInfo.serviceEndDt && this.ownerDetailInfo.endTime) {
        serviceEndDate = this.ownerDetailInfo.serviceEndDt + ' ' +this.ownerDetailInfo.endTime
      }
      SystemManageApi.updateOwner({
        ownerId: this.ownerDetailInfo.ownerId,
        ownerName: this.ownerDetailInfo.ownerName,
        pointFeeRate: Number(pointFeeRate),
        pointExchangeRate: Number(pointExchangeRate),
        closeDate: this.ownerDetailInfo.closeDate,
        expirationMonth: this.ownerDetailInfo.expirationMonth,
        resUserName: this.ownerDetailInfo.respUserName,
        resUserTelNo: this.ownerDetailInfo.respUserTel,
        resUserEmail: this.ownerDetailInfo.respUserEmail,
        resContractNo: this.ownerDetailInfo.respUserContractNo,
        companyAddress: this.ownerDetailInfo.companyAddress,
        companyTelNo: this.ownerDetailInfo.companyTel,
        serviceStartDateTime: serviceStartDate,
        serviceEndDateTime: serviceEndDate,
      })
      .catch((error) => {
        errorCodeMsg(error, this)
      })
        .then(({data}) => {
          if(!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          this.$messageIotSuccess(this.$t("message.common.createSuccess", {
            field: this.$t("label.router.owner"),
          }));
          this.$router.push({
            name: "system-owner-detail",
            params: {
              ownerId: this.paramOwnerId,
            },
          });
        }).finally(() => {
          this.showLoading = false;
        });
    },
    startTimeSelect(val) {
      if (val) {
        this.weekDays= weeksDay[new Date(val).getDay()]
      }
      if(!this.ownerDetailInfo.startTime) {
        this.ownerDetailInfo.startTime = "00:00"
      }
    },
    timeSlot () {
        let step = 15
        var date = new Date("2021-01-14 00:00:00")
        let timeArr = [];
        var slotNum = 24*60/step
        for (var f = 0; f < slotNum; f++) {
            var time = new Date(Number(date.getTime()) + Number(step*60*1000*f))
            var hour = '', sec = '';
            time.getHours() < 10 ? hour = '0' + time.getHours() : hour = time.getHours()
            time.getMinutes() < 10 ? sec = '0' + time.getMinutes() : sec = time.getMinutes()
            timeArr.push(hour + ':' + sec)
        }
        return timeArr
    },
    /**
     *「アカウント情報」画面に遷移する
     * system-account-detail
     */
    goAccountDetail(value){
      this.$router.push({
        name:"system-account-detail",
        params:{
          accountId:value
        }
      })
    },
    endTimeSelect(val) {
      if (val) {
        this.weekDay = weeksDay[new Date(val).getDay()]
      }
      if(!this.ownerDetailInfo.endTime) {
        this.ownerDetailInfo.endTime = "00:00"
      }
    },
  },
  created() {
    for (let i = 0; i < 31; i++) {
      this.closeDateList.push({
        label: (i + 1) + '日',
        value: i + 1
      })
    }
    for (let i = 0; i < 6; i++) {
      this.expirationMonthList.push({
        label: i + 1,
        value: i + 1
      })
    }
    this.timeList=this.timeSlot()
    this.$authCheck("010203")
    this.ownerDetailInfo.userList = [];
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/owners/search",
        title: "label.router.owner",
      },
      {
        path: "",
        title: "label.router.ownerEdit",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
  }
};
</script>

<style lang="scss" scoped>
::v-deep .cancel-width{
  .my-button{
    width: 152px;
    height: 32px;
  }
}
.must-top{
  color:#525250;
}
.width-204 {
  width: 204px;
  height: 27px;
  margin-top: 4px;
}
.width-528{
  width: 528px;
}
.owner-edit-form::v-deep {
  .el-input__inner {
    width: 324px;
    height: 44px !important;
    padding:0px 16px 0px 16px;
  }
}
.pointRate::v-deep {
  .el-input__inner {
    width: 120px;
    height: 44px !important;
    padding:0px 16px 0px 16px;
  }
}
::v-deep .owner-serch-data-time{
  .el-input__inner {
    width: 188px !important;
    height: 40px !important;
    border: none;
    height: 40px;
    margin-left: 16px;
    border-radius: 4px !important;
    background-color: #F2F2ED;
    box-shadow: -2px -2px 5px #ffffff ,4px 5px 5px #E6E6E1 ;
  }
  .el-input__icon:before {
    display: none;
  }
}
.owners-search-respUserName::v-deep {
  .el-input__inner {
    width: 120px;
    height: 44px !important;
    padding:0px 16px 0px 16px;
  }
}
::v-deep .user-search-postalCode{
  .el-input__inner {
  width: 120px;
  height: 44px !important;
  border-radius: 8px !important;
  background: #F2F2ED;
  border: none;
  padding:0px 0px 0px 16px;
  box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
    4px 5px 5px #E6E6E1 inset, 4px 5px 5px #E6E6E1 inset;
  }
}
::v-deep .asterisk {
  .el-form-item__label::after{
    content: "*";
    color: #F56C6C;
    margin-right: 4px;
  }
}
::v-deep .el-form-item__label::before{
  display: none;
}
.width-120{
  width: 120px;
}
.height-44{
  height: 44px;
  margin-bottom: 40px;
}
.el-button--text{
  color: #606266;
}
.float-left {
  float: left;
}

.pick_date_box {
  width: 188px !important;
  height: 40px !important;
  border: none !important;
  background-color: #F7F7F2;
  ::v-deep .el-icon-date:before {
    display: none;
  }
  ::v-deep .el-icon-date:after {
    display: none;
  }
  ::v-deep.el-input__inner {
    width: 188px !important;
    height: 40px !important;
    font-size: 13px;
    padding-left: 20px;
    border: none;
    border-radius: 4px !important;
    background-color: #F2F2ED;
    box-shadow:
    -2px -2px 5px #ffffff ,4px 5px 5px #E6E6E1 ;
  }
}
.img-size {
  position: relative;
  left: -46px;
  top: 6px;
  position: relative;
  padding-left: 10px;
  -webkit-pointer-events: none;
  -moz-pointer-events: none;
  -ms-pointer-events: none;
  -o-pointer-events: none;
  pointer-events: none;
}
::v-deep .time-select {
  width: 120px;
  font-size: 15px;
  height: 40px;
  border-radius: 8px;
  box-shadow: -2px -2px 4px #fff,
              4px 4px 4px #E6E6E1;
    .el-input__inner {
    height: 40px;
    border-radius: 10px;
    background-color: #F2F2ED;
    border: 0;
    color: #525250;
  }
  .el-input__suffix {
    top: 0px;
  }
  .el-input__icon {
    line-height: 25px !important;
  }
}
::v-deep .el-form-item__error {
  width: 500px;
}
::v-deep .date-picker-background-color {
  .el-input__inner {
    background-color: #F2F2ED !important;
  }
}
::v-deep .date-time-select {
  .el-input__inner {
    width: 120px !important;
  }
}

.margin-bottom-0 {
  margin-bottom: 0px;
}

.line-height-44::v-deep {
  .el-form-item__label {
    line-height: 44px !important;
  }
}

.m-left-408 {
  margin-left: 408px;
}

.table-header-th-top-0::v-deep {
  .el-table__header th {
    padding-top: 0px !important;
  }
  .el-table__header th .cell {
    padding-top: 0px !important;
  }
}
</style>
